import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allMachines } from 'app/mocks/data/machines/all'

import { api, assets } from 'app/utils/constants'

import { SelfServiceTerminal } from 'app/types/machines/selfService'
import { Day } from 'app/types/shared/day'
import { TypeMachine } from 'app/types/shared/machine'

export const getSelfService = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.terminals.SELF_SERVICE}`,
    ({ params }) => {
        const { id } = params

        const fridgeWeightFound = allMachines.find(
            (machine) =>
                machine.id.toString() === id &&
                machine.category === TypeMachine.enum.FRIDGE_WEIGHT,
        )

        // Fridge weight not found
        if (!fridgeWeightFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<SelfServiceTerminal>({
            has_self_service: true,
            image: assets.ethik.KONSOLE_COLOR,
            time_slots: [
                {
                    day_start: Day.enum.MONDAY,
                    time_start: '09:00:00',
                    day_end: Day.enum.MONDAY,
                    time_end: '10:00:00',
                },
                {
                    day_start: Day.enum.MONDAY,
                    time_start: '10:00:00',
                    day_end: Day.enum.FRIDAY,
                    time_end: '18:00:00',
                },
                {
                    day_start: Day.enum.THURSDAY,
                    time_start: '09:00:00',
                    day_end: Day.enum.FRIDAY,
                    time_end: '18:00:00',
                },
            ],
        })
    },
)
